import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@services/auth/auth-guard.service';

const routes: Routes = [
  { path: '', redirectTo: 'private/main', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./public/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'private',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./private/private-routing.module').then(
        m => m.PrivateRoutingModule
      ),
  },
  {
    path: 'network-required',
    loadChildren: () =>
      import('./public/network-required/network-required.module').then(
        m => m.NetworkRequiredPageModule
      ),
  },
  {
    path: 'restoration-ticket/:id',
    loadChildren: () =>
      import('./public/restoration-ticket/restoration-ticket.module').then(
        m => m.RestorationTicketPageModule
      ),
  },
  {
    path: 'maintenance-mode',
    loadChildren: () =>
      import('./public/maintenance-mode/maintenance-mode.module').then(
        m => m.MaintenanceModePageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      initialNavigation: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
